import React, { Component } from 'react';
import {Link, Switch, Route} from "react-router-dom";
import ContentBox from './ContentBox.js';
import ClientSelectCilindro from './ClientSelectCilindro';
import {cilindroGetPedidos} from '../api.js';
import PopupPedidoAnular from './PopupPedidoAnular';
import PopupPedidoReclamo from './PopupPedidoReclamo';
import ModalCampain from "./ModalCampain"
import moment from 'moment';
import ServiciosCilindroPedido from "./ServiciosCilindroPedido"
import {urls} from '../config.js';

export default class ServiciosCilindroPedidos extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchType: "days",
			searchPedido: "",
			filterDays: 30,
			pedidosDefault: [],
			trackingModal:{
				isShow: false,
				code: ""
			}
		};
	}	
	componentDidMount() {
		if(this.props.selectedService) this.getList();
	}	
	componentDidUpdate(prevProps) {
		if(prevProps.selectedService !== this.props.selectedService) this.filter();
	}
	getList(cb) {
		this.setState({
			loading: true, 
			pedidos: null, 
			pedidosMessage: "", 
			showAddress: false
		});
		
		cilindroGetPedidos((error, result) => {
			this.setState({loading: false});

			const {status} = result;
			const mapStatusResult = new Set(["error", "empty"]);

			if(error) {
				if(cb) cb(error);
				return console.log(error);
			}
			if( mapStatusResult.has(status) && cb ) cb();
			if( status === "empty" ) return this.setState({pedidosMessage: result.message});
			
			this.setState({
				// pedidos: result.data.map((pedido)=> {return {
					// ...pedido,
					// client_address: pedido.address,
					// client_street: pedido.street,
					// client_number: pedido.number,
					// client_block: pedido.block,
					// client_dept: pedido.dept,
					// client_location: pedido.location
				// }}),
				pedidos: result.data,
				pedidosDefault: result.data,
				// showAddress: this.state.searchType === "order_number" && result.data[0].clientCode !== this.props.selectedService.client_cod
			});
			this.filter();
		}, this.props.isEmpresa?"empresas":null);
		
	}
	filter() {
		const {filterDays, searchType} = this.state;

		if(searchType === 'order_number') return this.filterByOrderNumber();

		const fechaActual = moment();
		const pedidos = this.state.pedidosDefault.filter(item => {
			const dateCreation = moment(item.creationDateTime);
			const diferenceDays = fechaActual.diff(dateCreation, 'days');
			return diferenceDays <= filterDays;
		})
		.filter(item => item.shipToContactId === this.props.selectedService.client_id);
		
		const mapValueMonth = {
			30 : 'Último mes',
			90 : 'Últimos 3 meses',
			180 : 'Últimos 6 meses',
			365 :'Últimos 12 meses'
		}

		if(!pedidos.length) return this.setState({
			pedidosMessage: `Sin datos, para ${mapValueMonth[filterDays]}`, 
			pedidos: null
		});
			
		
		this.setState({ pedidos })
	}
	filterByOrderNumber() {
		const {searchPedido} = this.state;
		if(!searchPedido) return this.setState({ pedidos: this.state.pedidosDefault });

		const pedidos = this.state.pedidosDefault.filter(pedido => pedido.orderNumber === searchPedido);
		
		if(!pedidos.length) return this.setState({
			pedidosMessage: `Sin datos, para ${searchPedido}`, 
			pedidos: null
		});

		this.setState({ pedidos });
	}
	renderContentModal(){
		document.body.style.overflow = "hidden";
		return(
			<iframe 
			title='iframe-content-info-track' 
			className="track-modal-iframe" 
			src={urls.portal_pedidos_tracking_detalle + this.state.trackingModal.code}>
			</iframe>
		);
	}
	cancelModal(){
		document.body.style.overflow = "";
		this.setState({ trackingModal: {isShow:false}});
	}
	render() {
		return (
			<Switch>
			<Route exact path="/mis-servicios/cilindro/pedidos">
			<ContentBox loading={this.state.loading}>
				<div className="title-client-container clearfix">
					<h1>Pedidos</h1>
					<div className="client-number">
						<ClientSelectCilindro
							clientAddresStyle={{fontSize:14}} 
							hideClientCode={true}
							selected={this.props.selectedService} 
							services={this.props.services}
							setSelectedService={this.props.setSelectedService} />	
					</div>
				</div>
				<div className="col-100 left d-flex justify-between margin-bottom-40">
					<div className="filter-container grid-column-3">
						<div className="position-relative">
							<select value={this.state.searchType} onChange={(e) => {this.setState({searchType: e.target.value})}}>
								<option value="days">Periodo</option>
								<option value="order_number">Número de pedido</option>
							</select>
						</div>
						{this.state.searchType==="order_number"?<input type="text" value={this.state.searchPedido} onChange={(e)=>{this.setState({searchPedido: e.target.value})}} placeholder={"N° de Pedido"} style={{flex: 1, marginRight: "20px"}} />
						:<div className="position-relative">
							<select value={this.state.filterDays} onChange={(e) => {this.setState({filterDays: e.target.value})}}>
								<option value="30">Último mes</option>
								<option value="90">Últimos 3 meses</option>
								<option value="180">Últimos 6 meses</option>
								<option value="365">Últimos 12 meses</option>
							</select>
						</div>}
						<button className="button orange" onClick={() => {this.filter()}}>Filtrar</button>
					</div>
				</div>
				<div className="table-container">
					<table className="table1">
						<thead>
							<tr>
								<td>Fecha del Pedido</td>
								<td>Número Pedido</td>
								<td style={{minWidth: "180px"}}>Producto</td>
								<td>Monto Total</td>
								<td>Fecha Programada</td>
								<td>Estado</td>
								{this.state.showAddress?<td>Dirección</td>:null}
								<td></td>
								<td></td>
								<td>SEGUIMIENTO DEL PEDIDO</td>
								
							</tr>							
						</thead>
						<tbody>
							{this.state.pedidos && this.state.pedidos.map((pedido, i) => {
								// var address = "";
								// if(pedido.address && pedido.address.trim() !== "") address += pedido.address;
								// if(pedido.commune && pedido.commune.trim() !== "") {
								// 	if(address !== "") address += ", ";
								// 	address += pedido.commune;
								// }
								// if(pedido.region && pedido.region.trim() !== "") {
								// 	if(address !== "") address += ", ";									
								// 	address += pedido.region;
								// }
								var creationMoment = moment(pedido.creationDateTime);

								return(
									<tr key={i}>
										<td className="white-space-pre">
											{creationMoment.format("DD-MM-YYYY")}
											<br/>
											{creationMoment.format("HH:mm")}
										</td>
										<td>
											{pedido.orderNumber}
										</td>
										<td>
											{ pedido.descriptionCode }
										</td>
										<td>
											${parseInt(pedido.amount).toLocaleString("de")}
										</td>
										<td className="white-space-pre">
											{moment(pedido.scheduledDate, "YYYY-MM-DD").format("DD-MM-YYYY")}
										</td>
										<td>
											{pedido.status}
										</td>
										{/* {this.state.showAddress &&
											<td>
												{address}
											</td> 
										*/}
										<td>
											{pedido && pedido.claimDelay &&
												<div className="linkA-container" onClick={()=>{this.setState({reclamar_order: pedido})}}>
													<span>No he recibido mi pedido</span>
												</div>
											}
										</td>
										<td>
											{pedido && pedido.cancel_order && 
												<div className="linkA-container" onClick={() => this.setState({anular_order: pedido})}>
													<span>Anular</span>
												</div>
											}
										</td>
										{/* <td className="linkA-container">
												<Link to={"/mis-servicios/cilindro/pedidos/" + pedido.orderNumber}>
													Ver Detalle
												</Link>
										</td> */}
										<td>
											<button 
											className="button orange"
											onClick={()=>{
												this.setState({trackingModal: {isShow:true, code: pedido.orderNumber}})
											}}
											>
												Consultar
											</button>
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
					{!this.state.pedidos?<p>{this.state.pedidosMessage}</p>:null}
				</div>
			{this.state.anular_order?<PopupPedidoAnular isEmpresa={this.props.isEmpresa} 
				client={this.props.selectedService} 
				order={this.state.anular_order} 
				cancel={()=>this.setState({anular_order: null})} 
				confirm={true||this.confirmModal.bind(this)} 
				show={this.state.anular_order} 
				reload_list={()=>{this.filter()}}  
				business_line="cylinder"/>:null}
			{this.state.reclamar_order?<PopupPedidoReclamo isEmpresa={this.props.isEmpresa} 
				order_number={this.state.reclamar_order?this.state.reclamar_order.orderNumber:null} 
				client_cod={this.props.selectedService?this.props.selectedService.client_cod:null} 
				cancel={()=>this.setState({reclamar_order: null})} 
				confirm={null} 
				show={this.state.reclamar_order}
				hasClaim={this.state.reclamar_order.hasClaim}
				business_line="cylinder"/>:null}
			{this.state.trackingModal.isShow && 
				<ModalCampain 
				closeRight={true} 
				expandFull={true} 
				renderContent={()=>this.renderContentModal()} 
				cancel={()=>this.cancelModal()} 
				show={this.state.trackingModal.isShow}
				/>
			}
			</ContentBox>
			</Route>
			<Route path="/mis-servicios/cilindro/pedidos/:id"
      				render={(data)=> 
					<ServiciosCilindroPedido isEmpresa={this.props.isEmpresa} pedido_id={data.match.params.id} />}>
            </Route>
		</Switch>
		);
	}
}